import { render, staticRenderFns } from "./readlyUploadOrder.vue?vue&type=template&id=05960006&scoped=true"
import script from "./readlyUploadOrder.vue?vue&type=script&lang=js"
export * from "./readlyUploadOrder.vue?vue&type=script&lang=js"
import style0 from "./readlyUploadOrder.vue?vue&type=style&index=0&id=05960006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05960006",
  null
  
)

export default component.exports